module.exports = __webpack_public_path__ + "images/149_1024.jpg";